// Aufrufe des Projektteasers. Die Schnittstelle ist im gemeinsamen Auftrag
// festgelegt (Server und Oberflaeche wurden gleichzeitig gebaut) - hier nichts
// erfinden, was der Server nicht kennt.
//
// fetch statt axios: Beim Erzeugen braucht es das PDF als Blob UND die Header
// x-teaser-bitrix / x-teaser-phase / content-disposition; so laufen alle
// Aufrufe gleich und Fehler kommen einheitlich als { detail }.

import {
  TEASER_CONTRACT_KEY, dateinameAusDisposition, ersatzDateiname, fehlerMeldung,
} from '../../lib/ffpvTeaser';

// Wie im FFPV-Flyer: Das Mapping liegt direkt in contracts-am.
const CONTRACTS_AM_URL = process.env.REACT_APP_CONTRACTS_AM_URL
  || 'https://gjouokpgdwlcdjdenpdt.supabase.co/functions/v1/contracts-am';

function fehlerMitStatus(meldung, status) {
  const fehler = new Error(meldung);
  fehler.status = status;
  return fehler;
}

async function rufe(url, optionen) {
  let antwort;
  try {
    antwort = await fetch(url, optionen);
  } catch {
    // fetch wirft nur, wenn gar keine Antwort kam (offline, CORS, abgebrochen).
    throw fehlerMitStatus(fehlerMeldung(0), 0);
  }
  if (!antwort.ok) {
    const daten = await antwort.json().catch(() => ({}));
    throw fehlerMitStatus(fehlerMeldung(antwort.status, daten?.detail || daten?.error), antwort.status);
  }
  return antwort;
}

function mitParametern(basis, parameter) {
  // href statt origin: origin ist in manchen Umgebungen der Text "null"
  // (Datei, abgeschottete Frames), und new URL() wirft dann.
  const url = new URL(basis, window.location.href);
  Object.entries(parameter).forEach(([schluessel, wert]) => url.searchParams.set(schluessel, wert));
  return url.toString();
}

/** GET ?op=ffpv-teaser-pending | -history | -template */
export async function teaserLesen(apiBase, op, headers) {
  const antwort = await rufe(mitParametern(apiBase, { op, _ts: String(Date.now()) }), { headers });
  return antwort.json();
}

/** POST { action: 'ffpv-teaser-preview' | 'ffpv-teaser-template-save', … } */
export async function teaserSenden(apiBase, nutzlast, headers) {
  const antwort = await rufe(apiBase, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(nutzlast),
  });
  return antwort.json();
}

/**
 * POST ffpv-teaser-generate → PDF. Liefert das Blob, den Dateinamen und was
 * der Server ueber Bitrix und die Phase meldet (null, wenn der Header fehlt).
 */
export async function teaserErzeugen(apiBase, nutzlast, headers) {
  const antwort = await rufe(apiBase, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'ffpv-teaser-generate', ...nutzlast }),
  });
  const blob = await antwort.blob();
  return {
    blob,
    dateiname: dateinameAusDisposition(antwort.headers.get('content-disposition'), ersatzDateiname(nutzlast.dealId)),
    bitrix: antwort.headers.get('x-teaser-bitrix'),
    phase: antwort.headers.get('x-teaser-phase'),
  };
}

export async function mappingLaden(headers) {
  const antwort = await rufe(mitParametern(CONTRACTS_AM_URL, { op: 'mapping', contract_key: TEASER_CONTRACT_KEY }), { headers });
  const daten = await antwort.json();
  return { felder: daten?.mapping?.fields || {}, gespeichertAm: daten?.mapping?.updatedAt || null };
}

export async function mappingSpeichern(felder, headers) {
  await rufe(CONTRACTS_AM_URL, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ op: 'mapping', contract_key: TEASER_CONTRACT_KEY, fields: felder }),
  });
}

/** Legt ein Blob als Datei ab (Download im Browser). */
export function alsDateiSpeichern(blob, dateiname) {
  const url = URL.createObjectURL(blob);
  const anker = document.createElement('a');
  anker.href = url;
  anker.download = dateiname;
  document.body.appendChild(anker);
  anker.click();
  anker.remove();
  // Erst nach dem Klick freigeben - manche Browser lesen die URL verzoegert.
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
